// Loan health dashboard query hook. One key feeds the tab-strip badges,
// the Overview scorecard, and the needs-attention feed, so the three
// surfaces can never disagree on a severity.

import { useQuery } from "@tanstack/react-query";
import {
  loanHealthApi,
  type LoanGradeRowDto,
  type LoanHealthDto,
} from "@/api/portfolioAdmin/loanHealthApi";

export const loanHealthKeys = {
  health: (loanId: string) =>
    ["portfolio-admin", "loan", loanId, "health"] as const,
  grades: (loanIds: string[]) =>
    ["portfolio-admin", "loans", "grades", [...loanIds].sort().join(",")] as const,
};

export function useLoanHealth(loanId: string | undefined) {
  return useQuery<LoanHealthDto>({
    queryKey: loanHealthKeys.health(loanId ?? ""),
    queryFn: () => loanHealthApi.get(loanId!),
    enabled: !!loanId,
  });
}

/** Batch grade rows for the loans list / portfolio rollups — the same
 *  server computation as the per-loan endpoint, one request for N loans. */
export function useLoanGrades(loanIds: string[]) {
  return useQuery<LoanGradeRowDto[]>({
    queryKey: loanHealthKeys.grades(loanIds),
    queryFn: () => loanHealthApi.grades(loanIds),
    enabled: loanIds.length > 0,
  });
}
